module.exports = __webpack_public_path__ + "static/media/rejected.17a4c1af.svg";